<template>
  <div class="outcome-item">
    <div class="outcome-item-main">
      <div class="outcome-item-main-wrapper">
        <div class="intro">Basado en sus respuestas:</div>
        <h3><i class="fas fa-check"></i> {{ titleText }}</h3>
        <div v-if="introDescription" class="intro-description">
          {{ introDescription }}
        </div>
        <div class="button-wrapper">
          <a
            :href="buttonUrl"
            class="button"
            @click="trackBridgeToProductSelector"
          >
            {{ buttonText }} <i class="fas fa-angle-right"></i>
          </a>
        </div>
        <div class="thanks">
          Gracias por compartir tus respuestas. ¡Esperamos que te sientas mejor
          pronto!
        </div>
      </div>
    </div>
    <div class="outcome-item-cta">
      <div class="outcome-item-cta-wrapper">
        <p v-html="outcomeDescription"></p>
        <div class="product-image">
          <a :href="buttonUrl">
            <img :src="productImageUrl" :alt="productImageAlt" />
          </a>
        </div>
        <div class="symptom-checker">
          <img
            src="@/assets/logo-symptomchecker.svg"
            alt="Symptom Checker my Monistat® Logo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'monistat-symptom-checker-outcome',
  props: {
    outcome: {
      type: Object,
      required: true
    }
  },
  computed: {
    titleText() {
      return this.$props.outcome.titleText
    },
    buttonUrl() {
      return this.$props.outcome.buttonUrl
    },
    buttonText() {
      return this.$props.outcome.buttonText
    },
    productImageUrl() {
      return require(`@/assets/${this.$props.outcome.productImageUrl}`)
    },
    productImageAlt() {
      return this.$props.outcome.titleText
    },
    outcomeDescription() {
      return this.$props.outcome.outcomeDescription
    },
    introDescription() {
      return typeof this.$props.outcome.introDescription === 'string'
        ? this.$props.outcome.introDescription
        : false
    }
  },
  methods: {
    ...mapActions(['sendAnalyticsRequest']),
    trackBridgeToProductSelector() {
      if (this.buttonUrl === '/seleccionador-de-productos') {
        this.sendAnalyticsRequest({
          type: 'custom',
          data: { action: 'bridge-to-ps', label: 'bridge-to-ps' }
        })
      }
    }
  }
}
</script>
